// @ts-check
class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector("#predictive-search");

		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		// Send Microsoft Clarity event for search tracking
		if (typeof window.clarity === 'function') {
			window.clarity("event", "searchTyped");
		}

		fetch(
			`${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search`
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				console.log(response);
				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector("#shopify-section-predictive-search").innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	open() {
		// this.predictiveSearchResults.style.display = "block";
	}

	close() {
		// this.predictiveSearchResults.style.display = "none";
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define("predictive-search", PredictiveSearch);
